import { render, staticRenderFns } from "./JobPreviewDataForCompany.vue?vue&type=template&id=55e397ee&scoped=true"
import script from "./JobPreviewDataForCompany.vue?vue&type=script&lang=js"
export * from "./JobPreviewDataForCompany.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewDataForCompany.vue?vue&type=style&index=0&id=55e397ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e397ee",
  null
  
)

export default component.exports